@if (isSiteContext) {
  <header class="content-header">
    <h4 class="vision-h4">Tasks</h4>
  </header>
}

<div class="action-bar" [ngClass]="{ 'content-header': isSiteContext }">
  <fw-button-toggle class="view-toggle" test-id="view-toggle" [value]="viewFilter" (change)="changeView($event)">
    <fw-button-toggle-item title="All tasks" value="all" [class.hidden]="!isSiteAdmin && !canManage" />
    <fw-button-toggle-item title="Assigned to me" value="assigned" />
    <fw-button-toggle-item title="Created by me" value="created" />
  </fw-button-toggle>
  @if (canManage) {
    <div class="action-buttons">
      @if (shouldShowClearFiltersSort) {
        <fw-button
          leftIcon="filter-sort-delete"
          test-id="clear-filters"
          variant="outline"
          [fwTooltip]="clearFilterSortTooltip"
          (click)="changeView(filters.get('viewFilter').value)"
        >
          Clear Filters
        </fw-button>
      }
      @if (someTasksSelected || allTasksSelected) {
        <fw-button
          color="danger"
          leftIcon="trash-delete"
          test-id="delete-tasks"
          variant="outline"
          [disabled]="!canDeleteSelection"
          [fwTooltip]="canDeleteSelection ? '' : 'You do not have permission to delete the selected tasks.'"
          (click)="deleteTasks(getSelectedTasks())"
        >
          Delete Selected Tasks
        </fw-button>
      }
      @if (canReadTaskReview && selectionValidViewMultiple) {
        <fw-button color="primary" test-id="view-multiple" variant="solid" (click)="viewSelectedTasks()">
          Launch Tasks in Viewer
        </fw-button>
      }
      <fw-button
        color="primary"
        fwTooltip="Launch tasks creation panel"
        mat-flat-button
        test-id="new-tasks"
        variant="solid"
        (click)="newTasks()"
      >
        New Tasks
      </fw-button>
    </div>
  }
  <fw-button
    color="primary"
    leftIcon="column-edit"
    test-id="open-columns-menu"
    variant="outline"
    [matMenuTriggerFor]="filterColumnMenu"
  >
    Edit Columns
  </fw-button>
  <mat-menu #filterColumnMenu="matMenu" class="columns-menu" test-id="columns-menu">
    @for (column of disabledColumns; track column) {
      <mat-checkbox
        class="mat-menu-item"
        [attr.test-id]="'column-checkbox-' + column.key"
        (change)="persistColumns()"
        (click)="$event.stopPropagation()"
        [(ngModel)]="column.enabled"
      >
        {{ column.label }}
      </mat-checkbox>
    }
  </mat-menu>
</div>

<div [ngClass]="{ 'content-body': isSiteContext }">
  <div class="table-wrapper">
    <table
      mat-table
      matSort
      matSortDisableClear
      [dataSource]="tasksData$"
      [matSortActive]="tasksSort$.value.active"
      [matSortDirection]="tasksSort$.value.direction"
      (matSortChange)="tasksSort$.next($event)"
    >
      <ng-container matColumnDef="checkbox">
        <th *matHeaderCellDef mat-header-cell>
          <mat-checkbox
            test-id="select-all-tasks"
            test-id="select-all-tasks-checkbox"
            [checked]="allTasksSelected"
            [disabled]="!selectableTasksPresent"
            [indeterminate]="someTasksSelected"
            (change)="setAllTasksSelected($event.checked)"
          />
        </th>
        <td *matCellDef="let element" class="text-left" mat-cell>
          <mat-checkbox
            [attr.test-id]="'select-project-' + element.projectId"
            [checked]="element.selected"
            [disabled]="!authorizedProjects[element.projectId]"
            [fwTooltip]="
              !authorizedProjects[element.projectId] ? 'You do not have permission to delete the selected tasks.' : null
            "
            [fwTooltip]="
              !authorizedProjects[element.projectId] ? 'You do not have permission to delete the selected tasks.' : null
            "
            (change)="selectRow($event.checked, element)"
            (click)="$event.stopPropagation()"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="project">
        <th *matHeaderCellDef mat-header-cell>
          <project-picker
            class="small-form-field"
            test-id="project-filter"
            [useMultiSelect]="true"
            [useSolidBackground]="false"
            [(multiValue)]="projectFilter"
          />
        </th>
        <td *matCellDef="let element" fwTooltip="{{ element.projectLabel }}" mat-cell>
          {{ element.projectLabel }}
        </td>
      </ng-container>

      <ng-container matColumnDef="task_id">
        <th *matHeaderCellDef class="task-id full-width" mat-header-cell mat-sort-header>
          <mat-form-field appearance="outline" class="small-form-field">
            <input
              autocomplete="off"
              matInput
              placeholder="Task ID"
              test-id="task-id-filter"
              type="text"
              [formControl]="$any(filters.get('taskId'))"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            />
          </mat-form-field>
        </th>
        <td *matCellDef="let element" class="task-id" mat-cell>
          <div class="flex-wrapper">
            <span [fwTooltip]="element.taskId">{{ element.taskId }}</span>
            <mat-icon
              class="xs"
              fwTooltip="View Read Task"
              (click)="$event.stopPropagation(); viewTask(element._id, element.viewer)"
              >panorama
            </mat-icon>
            @if (canDownloadFiles(element.projectId)) {
              <mat-icon
                class="xs"
                fwTooltip="Download Associated File"
                (click)="$event.stopPropagation(); downloadTaskFiles(element)"
                >cloud_download
              </mat-icon>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="task_type">
        <th *matHeaderCellDef class="task-type" mat-header-cell>Task Type</th>
        <!-- TODO // uncomment when more protocols are available
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="task-type full-width">
          <mat-form-field appearance="outline">
            <mat-select test-id="project-roles-filter" [formControl]="filters.get('taskType')" placeholder="Task Type"
              (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
              <mat-option *ngFor="let option of taskTypeOptions" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        -->
        <td *matCellDef="let element" class="task-type" mat-cell [fwTooltip]="getTaskTypeDisplay(element)">
          {{ getTaskTypeDisplay(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="container">
        <th *matHeaderCellDef mat-header-cell>Container</th>
        <td *matCellDef="let element" mat-cell>
          <fw-ellipsis [text]="element?.container?.label || ''" [tooltip]="element?.container?.hierarchy" />
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th *matHeaderCellDef class="full-width" mat-header-cell mat-sort-header>
          <app-typeahead
            class="full-width small-form-field"
            placeholder="Assignee"
            test-id="assignee-filter"
            [options]="userOptions"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            [(value)]="assigneeFilter"
          />
        </th>
        <td *matCellDef="let element" mat-cell [fwTooltip]="element.assignee?._id">
          <div class="flex-wrapper">
            <app-avatar [enableAnimation]="true" [enablePopover]="false" [users]="element.assignee" />
            <span class="ellipsis-block"> {{ element.assignee?.firstname }} {{ element.assignee?.lastname }} </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="creator">
        <th *matHeaderCellDef class="full-width" mat-header-cell mat-sort-header>
          <app-typeahead
            class="full-width small-form-field"
            placeholder="Creator"
            test-id="creator-filter"
            [options]="userOptions"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            [(value)]="creatorFilter"
          />
        </th>
        <td *matCellDef="let element" mat-cell [fwTooltip]="element.creator?._id">
          <div class="flex-wrapper">
            <app-avatar [enableAnimation]="true" [enablePopover]="false" [users]="element.creator" />
            <span class="ellipsis-block"> {{ element.creator?.firstname }} {{ element.creator?.lastname }} </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th *matHeaderCellDef class="created" mat-header-cell mat-sort-header>Created</th>
        <td *matCellDef="let element" class="created" mat-cell [fwTooltip]="element.created?.tooltip">
          {{ element.created.display }}
        </td>
      </ng-container>

      <ng-container matColumnDef="due">
        <th *matHeaderCellDef class="due-date" mat-header-cell mat-sort-header>Due Date</th>
        <td
          *matCellDef="let element"
          class="due-date"
          mat-cell
          [fwTooltip]="element.dueDate.tooltip"
          [ngClass]="{ red: element.dueDate.isOverdue }"
        >
          <div class="flex-wrapper">
            @if (element.dueDate.isOverdue) {
              <mat-icon class="xs">warning_amber</mat-icon>
            }
            {{ element.dueDate.display }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef class="status full-width" mat-header-cell mat-sort-header>
          <mat-form-field appearance="outline" class="full-width small-form-field">
            <mat-select
              placeholder="Status"
              test-id="status-filter"
              [formControl]="$any(filters.get('status'))"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              @for (option of statusOptions; track option) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let element" class="status" mat-cell>
          <div class="flex-wrapper" [ngClass]="element.status.className">
            @if (element.status.isComplete) {
              <mat-icon class="xs">check_circle_outline</mat-icon>
            }
            {{ element.status.display }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="tag">
        <th *matHeaderCellDef mat-header-cell test-id="tag-header">
          <mat-form-field class="small-form-field" [formGroup]="filters">
            <mat-chip-grid #chipList formControlName="tags">
              @for (value of filters.controls.tags.value; track value; let chipIndex = $index) {
                <mat-chip-row class="chip" (removed)="removeTagFilter(chipIndex)">
                  {{ value }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              }
              @if (filters?.controls?.tags?.value?.length === 0) {
                <input
                  #chipInput
                  formControlName="tagText"
                  placeholder="Tags"
                  test-id="filter-chips"
                  [matChipInputAddOnBlur]="true"
                  [matChipInputFor]="chipList"
                  (matChipInputTokenEnd)="addTagFilter($event)"
                />
              }
            </mat-chip-grid>
          </mat-form-field>
        </th>
        <td *matCellDef="let element; let i = index" mat-cell style="position: relative">
          <mat-chip-grid #chipList class="chip-list" [attr.test-id]="'chip-list-' + i">
            @for (tag of element.tags; track tag) {
              <mat-chip-row>
                {{ tag }}
              </mat-chip-row>
            }
          </mat-chip-grid>
          <div
            class="chip-ellipsis"
            [class.hidden]="tagOverflows[i]?.hiddenItemCount === 0"
            [style.left]="tagOverflows[i] ? tagOverflows[i].ellipsisOffsetLeft : 'none'"
          >
            @if (tagOverflows[i]?.hiddenItemCount > 0) {
              <mat-chip-option class="more-chip" [fwTooltip]="tagOverflows[i].hiddenItemsTooltip">
                +{{ tagOverflows[i] ? tagOverflows[i].hiddenItemCount : '' }}
              </mat-chip-option>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" class="text-right list-action-buttons" mat-cell>
          <mat-icon
            class="action-icon xs"
            [fwTooltip]="
              !authorizedProjects[element.projectId]
                ? 'You do not have permission to delete the selected tasks.'
                : 'Delete'
            "
            [ngClass]="{ disabled: !authorizedProjects[element.projectId] }"
            (click)="$event.stopPropagation(); authorizedProjects[element.projectId] && deleteTasks([element])"
          >
            delete
          </mat-icon>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        class="list-action-hover"
        mat-row
        (click)="editTask(row)"
      ></tr>
    </table>
    <div #fwLoadTrigger class="load-trigger" (fwLoadTrigger)="loadMore()"></div>

    @if (isLoading) {
      <fw-loading />
    }

    @if (!isLoading && !hasData && !hasLoadingError) {
      <div class="empty blank-state">
        <mat-icon class="sm raised blue">block</mat-icon>
        <p>No Tasks</p>
      </div>
    }

    @if (hasLoadingError) {
      <div class="empty blank-state">
        <mat-icon class="sm raised red">priority_high</mat-icon>
        <p>There was an error loading tasks</p>
      </div>
    }
  </div>
</div>
